import React from 'react'
import AlexaGrassoComp from '../../components/sponsorships/AlexaGrasso'

const AlexaGrasso = () => {
  return (
    <AlexaGrassoComp/>
  )
}

export default AlexaGrasso